import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/network_issues.png")